import Stage1Player5Room from "../shared/Stage1Player5Room";

export default function Five_Players_Stage1_Player5(props) {
  return <Stage1Player5Room {...props} playerCount={5} />;
}